module.exports = __webpack_public_path__ + "img/pro_seven_6.a7d396bc.jpg";